module.exports = __webpack_public_path__ + "img/pisa.62a7f73a.png";